import { render } from "./Breadcrumb.vue?vue&type=template&id=3a872d8a&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=3a872d8a&lang=scss&scoped=true"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a872d8a"]])

export default __exports__